import { ExportDataButton } from "components/ExportDataButton";
import { useTenant } from "hooks/useTenant";

export function FacilitiesExportButton({
  tenantId,
  filter,
  iconOnly,
}: {
  tenantId?: string;
  filter?: Record<string, any>;
  iconOnly?: boolean;
}) {
  const { tenant } = useTenant();

  return (
    <ExportDataButton
      exportType="facilities"
      disabled={!tenantId}
      tenantId={tenantId ?? ""}
      fileName={tenant?.name ? `${tenant.name}-facilities` : "facilities"}
      filter={filter}
      iconOnly={iconOnly}
    />
  );
}
